$('.Product__Slideshow .AspectRatio img').click(function(){
  const $width_image = $( window ).width();
  if($width_image < 768){
    $('.Product__ActionItem:first .RoundButton').trigger( "click" );
  }
});
$('.ProductForm__Variants .SizeSwatch').click(function(){
  setTimeout(function(){ 
    var $quan_sto = $('.QuantitySelector__CurrentQuantity').attr('data-quantity');
    var $quan_pro = Number($('.product-select_hide option:selected').attr('data-quantity'));
    if($quan_sto > $quan_pro){
      $('.skillsDouble.ProductForm__AddToCart').css('display', 'none');
      $('.sold_out').css('display', 'block');
    }else{
      $('.skillsDouble.ProductForm__AddToCart').css('display', 'block');
      $('.sold_out').css('display', 'none');
    }
  });
});

$('.QuantitySelector__CurrentQuantity').bind('click keyup', function(){
  var $quan = Number($(this).val());
  var $quan_pro = Number($('.product-select_hide option:selected').attr('data-quantity'));
  $(this).attr('data-quantity', $quan);
  if($quan < ($quan_pro + 1)){
    $('.skillsDouble.ProductForm__AddToCart').removeAttr('disabled', 'disabled');
    $('.skillsDouble.ProductForm__AddToCart').text('add to bag');
    
    $('.skillsDouble.ProductForm__AddToCart').css('display', 'block');
	$('.sold_out').css('display', 'none');
  }else{
    $('.skillsDouble.ProductForm__AddToCart').attr('disabled', 'disabled');
    $('.skillsDouble.ProductForm__AddToCart').text('our stock');
    $('.skillsDouble.ProductForm__AddToCart').css('display', 'none');
	$('.sold_out').css('display', 'block');
  }
});
